import { ReactComponent as ArrowLeftx } from '../../assets/images/admin/arrow_left.svg'
import { ReactComponent as ArrowRightx } from '../../assets/images/admin/arrow_right.svg'
import { ReactComponent as UnconfirmedBannerGraphicx } from '../../assets/images/admin/astronaut.svg'
import BillingCallsDesktopx from '../../assets/images/admin/billing/calls_desktop.png'
import BillingCallsMobilex from '../../assets/images/admin/billing/calls_mobile.png'
import BillingFilesDesktopx from '../../assets/images/admin/billing/files_desktop.png'
import BillingFilesMobilex from '../../assets/images/admin/billing/files_mobile.png'
import BillingMessagesDesktopx from '../../assets/images/admin/billing/messages_desktop.png'
import BillingMessagesMobilex from '../../assets/images/admin/billing/messages_mobile.png'
import BillingSupportDesktopx from '../../assets/images/admin/billing/support_desktop.png'
import BillingSupportMobilex from '../../assets/images/admin/billing/support_mobile.png'
import { ReactComponent as CallEndx } from '../../assets/images/admin/calls/call-end.svg'
import { ReactComponent as CallStartx } from '../../assets/images/admin/calls/call-start.svg'
import { ReactComponent as CallCycleCameraIconx } from '../../assets/images/admin/calls/cycle-camera.svg'
import { ReactComponent as FlipCamerax } from '../../assets/images/admin/calls/flip-camera.svg'
import { ReactComponent as MicrophoneMutedx } from '../../assets/images/admin/calls/mic-off.svg'
import { ReactComponent as MicrophoneOn1x } from '../../assets/images/admin/calls/mic-on-01.svg'
import { ReactComponent as MicrophoneOn2x } from '../../assets/images/admin/calls/mic-on-02.svg'
import { ReactComponent as MicrophoneOn3x } from '../../assets/images/admin/calls/mic-on-03.svg'
import { ReactComponent as MicrophoneOn4x } from '../../assets/images/admin/calls/mic-on-04.svg'
import { ReactComponent as MicrophoneOnx } from '../../assets/images/admin/calls/mic-on.svg'
import { ReactComponent as ReturnToCallx } from '../../assets/images/admin/calls/return-to-call.svg'
import { ReactComponent as ScreenOffxxxxxx } from '../../assets/images/admin/calls/screen-off.svg'
import { ReactComponent as ScreenOnxxxxxx } from '../../assets/images/admin/calls/screen-on.svg'
import { ReactComponent as Settingsx } from '../../assets/images/admin/calls/settings.svg'
import { ReactComponent as VideoOffx } from '../../assets/images/admin/calls/video-off.svg'
import { ReactComponent as VideoOnx } from '../../assets/images/admin/calls/video-on.svg'
import { ReactComponent as VideoPinOffx } from '../../assets/images/admin/calls/video-pin-off.svg'
import { ReactComponent as VideoPinOnx } from '../../assets/images/admin/calls/video-pin-on.svg'
import { ReactComponent as Checkx } from '../../assets/images/admin/check.svg'
import { ReactComponent as ComposerAttachIconx } from '../../assets/images/admin/composer/composer-attachment.svg'
import { ReactComponent as ComposerCameraIconx } from '../../assets/images/admin/composer/composer-camera.svg'
import { ReactComponent as ComposerHeadingsIconx } from '../../assets/images/admin/composer/composer-headings.svg'
import { ReactComponent as ComposerMicIconx } from '../../assets/images/admin/composer/composer-mic.svg'
import { ReactComponent as ComposerNoteIconx } from '../../assets/images/admin/composer/composer-note.svg'
import { ReactComponent as ComposerPhotoIconx } from '../../assets/images/admin/composer/composer-photo.svg'
import { ReactComponent as ComposerReactionIconx } from '../../assets/images/admin/composer/composer-reaction.svg'
import { ReactComponent as ComposerSubmitIconx } from '../../assets/images/admin/composer/composer-submit.svg'
import { ReactComponent as ComposerToolbarToggleIconx } from '../../assets/images/admin/composer/composer-toolbar-toggle.svg'
import { ReactComponent as FormattingBoldIconx } from '../../assets/images/admin/composer/formatting-bold.svg'
import { ReactComponent as FormattingBulletIconx } from '../../assets/images/admin/composer/formatting-bullet.svg'
import { ReactComponent as FormattingItalicIconx } from '../../assets/images/admin/composer/formatting-italic.svg'
import { ReactComponent as FormattingNumListIconx } from '../../assets/images/admin/composer/formatting-num-list.svg'
import { ReactComponent as FormattingQuoteIconx } from '../../assets/images/admin/composer/formatting-quote.svg'
import { ReactComponent as FormattingSizeIconx } from '../../assets/images/admin/composer/formatting-size.svg'
import { ReactComponent as FormattingUnderlineIconx } from '../../assets/images/admin/composer/formatting-underline.svg'
import { ReactComponent as CreateContactx } from '../../assets/images/admin/create-contact.svg'
import { ReactComponent as CreateTopicx } from '../../assets/images/admin/create-topic.svg'
import { ReactComponent as DirectChats } from '../../assets/images/admin/direct_chats.svg'
import { ReactComponent as EmojiIconx } from '../../assets/images/admin/Emoji.svg'
import { ReactComponent as GroupChats } from '../../assets/images/admin/group_chats.svg'
import { ReactComponent as CalendarIconx } from '../../assets/images/admin/inbox/calendar-icon.svg'
import { ReactComponent as CopyIconx } from '../../assets/images/admin/inbox/copy-to-clipboard-active.svg'
import { ReactComponent as CloseToggleIconx } from '../../assets/images/admin/inbox/icon_close.svg'
import { ReactComponent as SnoozeIconx } from '../../assets/images/admin/inbox/snooze-icon.svg'
import { ReactComponent as MenuAddx } from '../../assets/images/admin/menu_icons/menu-add.svg'
import { ReactComponent as MenuChatx } from '../../assets/images/admin/menu_icons/menu-chat.svg'
import { ReactComponent as MenuCollapseIconx } from '../../assets/images/admin/menu_icons/menu-collapse-up.svg'
import { ReactComponent as MenuContactsx } from '../../assets/images/admin/menu_icons/menu-contacts.svg'
import { ReactComponent as MenuConversationsx } from '../../assets/images/admin/menu_icons/menu-conversations.svg'
import { ReactComponent as MenuDashboardx } from '../../assets/images/admin/menu_icons/menu-dashboard.svg'
import { ReactComponent as MenuDeletex } from '../../assets/images/admin/menu_icons/menu-delete.svg'
import { ReactComponent as MenuExpandIconx } from '../../assets/images/admin/menu_icons/menu-expand-right.svg'
import { ReactComponent as MenuGroupChatParticipantsx } from '../../assets/images/admin/menu_icons/menu-groupchat-participant.svg'
import { ReactComponent as MenuGroupChatx } from '../../assets/images/admin/menu_icons/menu-groupchat.svg'
import { ReactComponent as MenuIntegrationsx } from '../../assets/images/admin/menu_icons/menu-integrations.svg'
import { ReactComponent as MenuLatestxx } from '../../assets/images/admin/menu_icons/menu-latest.svg'
import { ReactComponent as MenuLiveChatx } from '../../assets/images/admin/menu_icons/menu-live-chat.svg'
import { ReactComponent as MenuNewx } from '../../assets/images/admin/menu_icons/menu-new.svg'
import { ReactComponent as MenuFileOpenIconx } from '../../assets/images/admin/menu_icons/menu-open-file.svg'
import { ReactComponent as MenuSnoozedIconx } from '../../assets/images/admin/menu_icons/menu-topic-snoozed.svg'
import { ReactComponent as MenuVideox } from '../../assets/images/admin/menu_icons/menu-video.svg'
import { ReactComponent as MenuWelcomeMessagex } from '../../assets/images/admin/menu_icons/menu-welcome.svg'
import { ReactComponent as Overflowx } from '../../assets/images/admin/overflow.svg'
import { ReactComponent as PaperPlaneDudex } from '../../assets/images/admin/paper_plane_dude.svg'
import { ReactComponent as SpeakeasyLogox } from '../../assets/images/admin/speakeasy-logo.svg'
import { ReactComponent as SpeakeasyWordmarkx } from '../../assets/images/admin/speakeasy-wordmark.svg'
import DarkThemeImagex from '../../assets/images/admin/themes/dark-theme.png'
import LightThemeImagex from '../../assets/images/admin/themes/light-theme.png'
import OSDefaultThemeImagex from '../../assets/images/admin/themes/os-default-theme.png'
import { ReactComponent as TransparentLogoArtx } from '../../assets/images/admin/transparent_logo_art.svg'
import { ReactComponent as VoicemailIconx } from '../../assets/images/admin/voicemail-icon.svg'
import { ReactComponent as CollectionCarouselPreviewDarkUnselectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-carousel-preview-d-a.svg'
import { ReactComponent as CollectionCarouselPreviewDarkSelectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-carousel-preview-d-b.svg'
import { ReactComponent as CollectionCarouselPreviewLightUnselectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-carousel-preview-l-a.svg'
import { ReactComponent as CollectionCarouselPreviewLightSelectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-carousel-preview-l-b.svg'
import { ReactComponent as CollectionContactPreviewDarkUnselectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-contact-preview-d-a.svg'
import { ReactComponent as CollectionContactPreviewDarkSelectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-contact-preview-d-b.svg'
import { ReactComponent as CollectionContactPreviewLightUnselectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-contact-preview-l-a.svg'
import { ReactComponent as CollectionContactPreviewLightSelectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-contact-preview-l-b.svg'
import { ReactComponent as CollectionEmbedPreviewDarkUnselectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-embed-preview-d-a.svg'
import { ReactComponent as CollectionEmbedPreviewDarkSelectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-embed-preview-d-b.svg'
import { ReactComponent as CollectionEmbedPreviewLightUnselectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-embed-preview-l-a.svg'
import { ReactComponent as CollectionEmbedPreviewLightSelectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-embed-preview-l-b.svg'
import { ReactComponent as CollectionFloatingPreviewDarkUnselectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-floating-preview-d-a.svg'
import { ReactComponent as CollectionFloatingPreviewDarkSelectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-floating-preview-d-b.svg'
import { ReactComponent as CollectionFloatingPreviewLightUnselectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-floating-preview-l-a.svg'
import { ReactComponent as CollectionFloatingPreviewLightSelectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-floating-preview-l-b.svg'
import { ReactComponent as CollectionWidgetPreviewDarkUnselectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-widget-preview-d-a.svg'
import { ReactComponent as CollectionWidgetPreviewDarkSelectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-widget-preview-d-b.svg'
import { ReactComponent as CollectionWidgetPreviewLightUnselectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-widget-preview-l-a.svg'
import { ReactComponent as CollectionWidgetPreviewLightSelectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-widget-preview-l-b.svg'
import { ReactComponent as CollectionScrollPreviewDarkUnselectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-widget-scroll-d-a.svg'
import { ReactComponent as CollectionScrollPreviewDarkSelectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-widget-scroll-d-b.svg'
import { ReactComponent as CollectionScrollPreviewLightUnselectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-widget-scroll-l-a.svg'
import { ReactComponent as CollectionScrollPreviewLightSelectedx } from '../../assets/images/admin/welcome_messages/collection_previews/collection-widget-scroll-l-b.svg'
import OverlayWithButtonsx from '../../assets/images/admin/welcome_messages/overlay-01@3x.png'
import OverlayWithoutButtonsx from '../../assets/images/admin/welcome_messages/overlay-02@3x.png'
import OverlayRectx from '../../assets/images/admin/welcome_messages/overlay-video@3x.png'
import { ReactComponent as PlaceholderVideox } from '../../assets/images/admin/welcome_messages/placeholder-video.svg'
import { ReactComponent as WelcomeMessageAppearancex } from '../../assets/images/admin/welcome_messages/set-appearance.svg'
import { ReactComponent as WelcomeMessageSettingsx } from '../../assets/images/admin/welcome_messages/set-cog.svg'
import { ReactComponent as WelcomeMessageDragx } from '../../assets/images/admin/welcome_messages/set-drag.svg'
import { ReactComponent as WelcomeMessageLinkx } from '../../assets/images/admin/welcome_messages/set-link.svg'
import { ReactComponent as WelcomeMessageLoopx } from '../../assets/images/admin/welcome_messages/set-loop.svg'
import { ReactComponent as WelcomeMessagePlayx } from '../../assets/images/admin/welcome_messages/set-play.svg'
import { ReactComponent as WelcomeMessageSlashx } from '../../assets/images/admin/welcome_messages/set-slash.svg'
import { ReactComponent as WelcomeMessageTiktokx } from '../../assets/images/admin/welcome_messages/set-tiktok.svg'
import { ReactComponent as WelcomeMessageInstax } from '../../assets/images/admin/welcome_messages/set-insta.svg'
import { ReactComponent as WelcomeMessageTrashx } from '../../assets/images/admin/welcome_messages/set-trash.svg'
import { ReactComponent as WelcomeMessageTypex } from '../../assets/images/admin/welcome_messages/set-type.svg'
import { ReactComponent as TemplateBlankIconx } from '../../assets/images/admin/welcome_messages/template_blank.svg'
import { ReactComponent as TemplateContactFormIconx } from '../../assets/images/admin/welcome_messages/template_contact_form.svg'
import { ReactComponent as TemplateEmailCaptureIconx } from '../../assets/images/admin/welcome_messages/template_email_capture.svg'
import { ReactComponent as TemplateProductDemoIconx } from '../../assets/images/admin/welcome_messages/template_product_demo.svg'
import { ReactComponent as TemplateProductPurchaseIconx } from '../../assets/images/admin/welcome_messages/template_product_purchase.svg'
import WelcomeStepOnex from '../../assets/images/admin/welcome_messages/welcome-step-one.png'
import WelcomeStepThreex from '../../assets/images/admin/welcome_messages/welcome-step-three.png'
import WelcomeStepTwox from '../../assets/images/admin/welcome_messages/welcome-step-two.png'
import { ReactComponent as LoadingSpinnerIconx } from '../../assets/images/live_chat/loading_spinner.svg'
import { ReactComponent as MinimiseIconx } from '../../assets/images/live_chat/minimise.svg'
import { ReactComponent as PoweredByLogoDarkModexx } from '../../assets/images/live_chat/powered_by_logo_dark_mode.svg'
import { ReactComponent as PoweredByLogoXX } from '../../assets/images/live_chat/powered_by_logo.svg'
import { ReactComponent as SoundOffIconx } from '../../assets/images/live_chat/sound_off.svg'
import { ReactComponent as SoundOnIconx } from '../../assets/images/live_chat/sound_on.svg'
import { ReactComponent as Stackxxxx } from '../../assets/images/live_chat/stack.svg'
import { ReactComponent as WidgetLogoXXX } from '../../assets/images/live_chat/widget_logo.svg'
import { ReactComponent as InstagramLogoX } from '../../assets/images/admin/collections_import_wizard/instagram_logo.svg'
import { ReactComponent as TiktokLogoX } from '../../assets/images/admin/collections_import_wizard/tiktok_logo.svg'
import { ReactComponent as YoutubeLogoX } from '../../assets/images/admin/collections_import_wizard/youtube_logo.svg'
import { ReactComponent as ShopifyLogoX } from '../../assets/images/admin/collections_import_wizard/shopify_logo.svg'

export const OverlayWithButtons = OverlayWithButtonsx
export const OverlayWithoutButtons = OverlayWithoutButtonsx
export const OverlayRect = OverlayRectx

export const EmojiIcon = EmojiIconx

export const PaperPlaneDude = PaperPlaneDudex
export const TransparentLogoArt = TransparentLogoArtx

export const SpeakeasyLogo = SpeakeasyLogox
export const SpeakeasyWordmark = SpeakeasyWordmarkx

export const CloseToggleIcon = CloseToggleIconx
export const SnoozeIcon = SnoozeIconx

export const DirectChatsSVG = DirectChats
export const GroupChatsSVG = GroupChats

export const MenuLatest = MenuLatestxx
export const MenuGroupChat = MenuGroupChatx
export const MenuLiveChat = MenuLiveChatx
export const MenuGroupChatParticipants = MenuGroupChatParticipantsx
export const MenuChat = MenuChatx
export const MenuContacts = MenuContactsx
export const MenuConversations = MenuConversationsx
export const MenuDashboard = MenuDashboardx
export const MenuIntegrations = MenuIntegrationsx
export const MenuVideo = MenuVideox
export const MenuFileOpenIcon = MenuFileOpenIconx
export const MenuAddIcon = MenuAddx
export const MenuDeleteIcon = MenuDeletex

export const NewTopicIcon = MenuNewx

export const MenuExpandIcon = MenuExpandIconx
export const MenuCollapseIcon = MenuCollapseIconx
export const MenuSnoozedIcon = MenuSnoozedIconx

export const MenuWelcomeIcon = MenuWelcomeMessagex

export const CallEndIcon = CallEndx
export const CallStartIcon = CallStartx
export const CallCycleCameraIcon = CallCycleCameraIconx

export const MicrophoneMutedIcon = MicrophoneMutedx
export const MicrophoneOn = MicrophoneOnx
export const MicrophoneOn1 = MicrophoneOn1x
export const MicrophoneOn2 = MicrophoneOn2x
export const MicrophoneOn3 = MicrophoneOn3x
export const MicrophoneOn4 = MicrophoneOn4x

export const ReturnToCallIcon = ReturnToCallx

export const VideoOffIcon = VideoOffx
export const VideoOnIcon = VideoOnx

export const ScreenOffIcon = ScreenOffxxxxxx
export const ScreenOnIcon = ScreenOnxxxxxx

export const VideoPinOffIcon = VideoPinOffx
export const VideoPinOnIcon = VideoPinOnx

export const FlipCameraIcon = FlipCamerax

export const SettingsIcon = Settingsx

export const CreateTopicIcon = CreateTopicx
export const CreateContactIcon = CreateContactx

export const LightThemeImage = LightThemeImagex
export const DarkThemeImage = DarkThemeImagex
export const OSDefaultThemeImage = OSDefaultThemeImagex

export const UnconfirmedBannerGraphic = UnconfirmedBannerGraphicx

export const OverflowIcon = Overflowx
export const CheckIcon = Checkx

export const FormattingBoldIcon = FormattingBoldIconx
export const FormattingBulletIcon = FormattingBulletIconx
export const FormattingItalicIcon = FormattingItalicIconx
export const FormattingNumListIcon = FormattingNumListIconx
export const FormattingQuoteIcon = FormattingQuoteIconx
export const FormattingSizeIcon = FormattingSizeIconx
export const FormattingUnderlineIcon = FormattingUnderlineIconx

export const ComposerAttachIcon = ComposerAttachIconx
export const ComposerToolbarToggleIcon = ComposerToolbarToggleIconx
export const ComposerPhotoIcon = ComposerPhotoIconx
export const ComposerCameraIcon = ComposerCameraIconx
export const ComposerSubmitIcon = ComposerSubmitIconx
export const ComposerMicIcon = ComposerMicIconx
export const ComposerNoteIcon = ComposerNoteIconx
export const ComposerReactionIcon = ComposerReactionIconx
export const ComposerHeadingsIcon = ComposerHeadingsIconx

export const BillingCallsMobile = BillingCallsMobilex
export const BillingFilesMobile = BillingFilesMobilex
export const BillingMessagesMobile = BillingMessagesMobilex
export const BillingSupportMobile = BillingSupportMobilex

export const BillingCallsDesktop = BillingCallsDesktopx
export const BillingFilesDesktop = BillingFilesDesktopx
export const BillingMessagesDesktop = BillingMessagesDesktopx
export const BillingSupportDesktop = BillingSupportDesktopx

export const CopyIcon = CopyIconx
export const CalendarIcon = CalendarIconx

export const WidgetLogo = WidgetLogoXXX
export const PoweredByLogo = PoweredByLogoXX
export const PoweredByLogoDarkMode = PoweredByLogoDarkModexx
export const Stack = Stackxxxx
export const VoicemailIcon = VoicemailIconx

export const ArrowLeft = ArrowLeftx
export const ArrowRight = ArrowRightx

export const TemplateBlankIcon = TemplateBlankIconx
export const TemplateEmailCaptureIcon = TemplateEmailCaptureIconx
export const TemplateContactFormIcon = TemplateContactFormIconx
export const TemplateProductDemoIcon = TemplateProductDemoIconx
export const TemplateProductPurchaseIcon = TemplateProductPurchaseIconx

export const WelcomeStepOne = WelcomeStepOnex
export const WelcomeStepTwo = WelcomeStepTwox
export const WelcomeStepThree = WelcomeStepThreex

export const WelcomeMessageAppearance = WelcomeMessageAppearancex
export const WelcomeMessageLoop = WelcomeMessageLoopx
export const WelcomeMessagePlay = WelcomeMessagePlayx
export const WelcomeMessageTiktok = WelcomeMessageTiktokx
export const WelcomeMessageInsta = WelcomeMessageInstax
export const WelcomeMessageType = WelcomeMessageTypex
export const WelcomeMessageSettings = WelcomeMessageSettingsx
export const WelcomeMessageDrag = WelcomeMessageDragx
export const WelcomeMessageLink = WelcomeMessageLinkx
export const WelcomeMessageSlash = WelcomeMessageSlashx
export const WelcomeMessageTrash = WelcomeMessageTrashx

export const CollectionEmbedPreviewLightUnselected =
  CollectionEmbedPreviewLightUnselectedx
export const CollectionEmbedPreviewLightSelected =
  CollectionEmbedPreviewLightSelectedx
export const CollectionEmbedPreviewDarkUnselected =
  CollectionEmbedPreviewDarkUnselectedx
export const CollectionEmbedPreviewDarkSelected =
  CollectionEmbedPreviewDarkSelectedx

export const CollectionContactPreviewLightUnselected =
  CollectionContactPreviewLightUnselectedx
export const CollectionContactPreviewLightSelected =
  CollectionContactPreviewLightSelectedx
export const CollectionContactPreviewDarkUnselected =
  CollectionContactPreviewDarkUnselectedx
export const CollectionContactPreviewDarkSelected =
  CollectionContactPreviewDarkSelectedx

export const CollectionFloatingPreviewLightUnselected =
  CollectionFloatingPreviewLightUnselectedx
export const CollectionFloatingPreviewLightSelected =
  CollectionFloatingPreviewLightSelectedx
export const CollectionFloatingPreviewDarkUnselected =
  CollectionFloatingPreviewDarkUnselectedx
export const CollectionFloatingPreviewDarkSelected =
  CollectionFloatingPreviewDarkSelectedx

export const CollectionWidgetPreviewLightUnselected =
  CollectionWidgetPreviewLightUnselectedx
export const CollectionWidgetPreviewLightSelected =
  CollectionWidgetPreviewLightSelectedx
export const CollectionWidgetPreviewDarkUnselected =
  CollectionWidgetPreviewDarkUnselectedx
export const CollectionWidgetPreviewDarkSelected =
  CollectionWidgetPreviewDarkSelectedx

export const CollectionCarouselPreviewLightUnselected =
  CollectionCarouselPreviewLightUnselectedx
export const CollectionCarouselPreviewLightSelected =
  CollectionCarouselPreviewLightSelectedx
export const CollectionCarouselPreviewDarkUnselected =
  CollectionCarouselPreviewDarkUnselectedx
export const CollectionCarouselPreviewDarkSelected =
  CollectionCarouselPreviewDarkSelectedx

export const CollectionScrollPreviewLightUnselected =
  CollectionScrollPreviewLightUnselectedx
export const CollectionScrollPreviewLightSelected =
  CollectionScrollPreviewLightSelectedx
export const CollectionScrollPreviewDarkUnselected =
  CollectionScrollPreviewDarkUnselectedx
export const CollectionScrollPreviewDarkSelected =
  CollectionScrollPreviewDarkSelectedx

export const SoundOffIcon = SoundOffIconx
export const SoundOnIcon = SoundOnIconx
export const MinimiseIcon = MinimiseIconx
export const LoadingSpinner = LoadingSpinnerIconx
export const PlaceholderVideo = PlaceholderVideox

export const InstagramLogo = InstagramLogoX
export const TiktokLogo = TiktokLogoX
export const YoutubeLogo = YoutubeLogoX
export const ShopifyLogo = ShopifyLogoX
